import { defineMessages } from "react-intl";

export const messages = defineMessages({
  searchLabel: {
    id: "searchbar.button",
    defaultMessage: "Search",
    description: "Label for button in searchbar",
  },
});
